import ReactGA from 'react-ga4';

/**
 * GA4 Event Tracking Utilities
 */

// Track custom events
export const trackEvent = (category, action, label = '', value = 0) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: `${buttonName}${location ? ` - ${location}` : ''}`,
  });
};

// Track form submissions
export const trackFormSubmit = (formName, success = true) => {
  ReactGA.event({
    category: 'Form',
    action: success ? 'Submit Success' : 'Submit Failed',
    label: formName,
  });
};

// Track form field interactions
export const trackFormField = (formName, fieldName, action = 'Focus') => {
  ReactGA.event({
    category: 'Form Field',
    action: action,
    label: `${formName} - ${fieldName}`,
  });
};

// Track language changes
export const trackLanguageChange = (newLanguage) => {
  ReactGA.event({
    category: 'User Interaction',
    action: 'Language Change',
    label: newLanguage,
  });
};

// Track image gallery interactions
export const trackGalleryAction = (action, imageName = '') => {
  ReactGA.event({
    category: 'Image Gallery',
    action: action,
    label: imageName,
  });
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  ReactGA.event({
    category: 'User Engagement',
    action: 'Scroll Depth',
    label: `${depth}%`,
    value: depth,
  });
};

// Track outbound links
export const trackOutboundLink = (url, label = '') => {
  ReactGA.event({
    category: 'Outbound Link',
    action: 'Click',
    label: label || url,
  });
};

// Track email/phone clicks
export const trackContactClick = (type, value) => {
  ReactGA.event({
    category: 'Contact',
    action: `${type} Click`,
    label: value,
  });
};

// Track user timing (for performance monitoring)
export const trackTiming = (category, variable, value, label = '') => {
  ReactGA.event({
    category: 'Timing',
    action: category,
    label: `${variable}${label ? ` - ${label}` : ''}`,
    value: value,
  });
};

// Track exceptions/errors
export const trackError = (description, fatal = false) => {
  ReactGA.event({
    category: 'Error',
    action: fatal ? 'Fatal Error' : 'Non-Fatal Error',
    label: description,
  });
};
